import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getData, putData } from '../Services/api'

const POTypeEdit = () => {
    const { id } = useParams();
    const [values, setValues] = useState({ type_name: "", color: "#ffffff" });
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const fetchType = async () => {
        try {
            const res = await getData(`/po-types/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch po type details", error)
        }
    }

    useEffect(() => {
        fetchType();
    }, [id])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const res = await putData(`/po-types/update/${id}`, values);
            if (res.status) {
                toast.success(res.message || 'PO Type updated successfully');
                navigate('/po-types/po-type-list');
                setValues({ type_name: "", color: "#ffffff" })
            } else {
                toast.error(res.message)
            }
        } catch (error) {
            console.log("error PO Type update", error)
            toast.error(error.response.data.message || 'error')
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/po-types/po-type-list">PO Type</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Edit PO Type
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Edit PO Type</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Edit PO Type</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">PO Type Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter PO Type"
                                                        name='type_name'
                                                        value={values.type_name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mt-3">
                                                    <label className="form-label">PO Type Color (Background Highlight)</label>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <input
                                                            type="color"
                                                            className="form-control form-control-color"
                                                            name='color'
                                                            value={values.color || '#ffffff'}
                                                            onChange={handleChange}
                                                            style={{ width: '60px', height: '38px', padding: '0.2rem' }}
                                                        />
                                                        <span className="text-muted">{(values.color || '#ffffff').toUpperCase()}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/po-types/po-type-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default POTypeEdit
